'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-4.57764e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 -6.3777e-06 20C-6.3777e-06 13.3333 0.000247555 6.66667 -4.57764e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-4.57764e-05 0H28V20H-6.3777e-06L-4.57764e-05 0Z",
          fill: "#0B36B2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.6665 20V0H8.6665L22.6665 20Z",
          fill: "#FFD045"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3333 18.6667L16.3905 18.9428L16.6667 18L16.3905 17.0572L17.3333 17.3333L18.2761 17.0572L18 18L18.2761 18.9428L17.3333 18.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6668 14.6667L13.724 14.9428L14.0002 14L13.724 13.0572L14.6668 13.3334L15.6096 13.0572L15.3335 14L15.6096 14.9428L14.6668 14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9998 10.6667L11.057 10.9428L11.3332 10L11.057 9.05721L11.9998 9.33335L12.9426 9.05721L12.6665 10L12.9426 10.9428L11.9998 10.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33333 6.66667L8.39052 6.94281L8.66666 6L8.39052 5.05719L9.33333 5.33333L10.2761 5.05719L9.99999 6L10.2761 6.94281L9.33333 6.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66682 2.66669L5.72401 2.94283L6.00016 2.00002L5.72401 1.05721L6.66682 1.33335L7.60963 1.05721L7.33349 2.00002L7.60963 2.94283L6.66682 2.66669Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagBaAsset = forwardRef(FlagBaAsset);

export { VpFlagBaAsset as default };
